module.exports = __webpack_public_path__ + "static/media/1.14_preview.ffb84115.png";